<template>
  <DisplayContainer :label="'Memo'">
    <v-textarea
      v-model="memo"
      :placeholder="placeholder"
      :disabled="disabled"
      auto-grow
      clearable
      clear-icon="mdi-delete"
      class="input-field"
      @input="onInput"
    />
  </DisplayContainer>
</template>

<script>
import DisplayContainer from '@/components/elements/DisplayContainer.vue';

export default {
  name: 'MemoField',
  components: {
    DisplayContainer
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: 'Memo'
    },
    placeholder: {
      type: String,
      default: 'Memo'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    counter: {
      type: Number,
      default: 60
    }
  },
  data() {
    return {
      memo: this.value
    };
  },
  watch: {
    value(newVal) {
      this.memo = newVal;
    }
  },
  methods: {
    onInput(val) {
      this.$emit('input', val);
    }
  }
};
</script>
